import { useEffect, useState } from "react";
import { useApiClient } from "../../../hooks/useApiClient";
import { getUserEvaluation } from "../../../services/evaluationsService";
import { IEvaluationsResponse } from "../../../features/evaluations/Interfaces/IEvaluationInterface";

export function useUserEvaluation() {
  const { call, ready } = useApiClient();
  const [userEvaluation, setUserEvaluation] = useState<any>(null);
  const [loadingUserEvaluation, setLoadingUserEvaluation] = useState(true);
  const [errorUserEvaluation, setErrorUserEvaluation] = useState<Error | null>(null);

  useEffect(() => {
    if (!ready) return;

    (async () => {
      setLoadingUserEvaluation(true);
      setErrorUserEvaluation(null);
      try {
        const result = await call<IEvaluationsResponse>(getUserEvaluation);
        if (result) {
          setUserEvaluation(result);
        }
      } catch (err) {
        setErrorUserEvaluation(err as Error);
      } finally {
        setLoadingUserEvaluation(false);
      }
    })();
  }, [ready]);

  return { userEvaluation, loadingUserEvaluation, errorUserEvaluation };
}
